<template>
  <div class="page-add-risk-tip">
    <div class="tip-header--blue">
      <p>1.话术中添加的变量将根据实际情况转化成相应内容，例如“客户姓名”将转化成外屏登录的客户姓名，“理财经理”将转化成内屏登录的理财经理名字等等；</p>
      <p>2.话术变量在文本中以特殊颜色显示；</p>
    </div>
    <div class="risk-form-container">
      <el-form
        ref="addForm"
        :model="addData"
        :rules="rules"
        label-width="100px"
        style="flex: 1;"
      >
        <el-form-item
          label="话术名称"
          prop="riskTipName"
        >
          <el-input
            v-model="addData.riskTipName"
            placeholder="请输入风险话术名称，不超过50个字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="话术描述"
          prop="riskTipDescribe"
        >
          <el-input
            v-model="addData.riskTipDescribe"
            :autosize="{minRows: 3}"
            placeholder="请输入风险话术描述，不超过200个字"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="话术详情"
          prop="riskTipDetails"
        >
          <div
            @blur="handleContentBlur"
            @paste="handlePaste"
            ref="editContent"
            contenteditable
            placeholder="请输入风险话术详情，不超过500个字"
            style="min-height: 300px;"
          ></div>
        </el-form-item>
        <el-form-item label="话术状态">
          <el-select v-model="addData.status">
            <el-option
              v-for="status in riskTipStatusList"
              :key="status.value"
              :label="status.label"
              :value="status.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="width: 200px;text-align: right;">
        <el-dropdown
          @command="handleCommand"
          class="risk-tip"
        >
          <el-button type="primary">
            添加变量<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu
            slot="dropdown"
            class="risk-tip"
          >
            <el-dropdown-item
              v-for="param in paramList"
              :key="param.value"
              :command="param"
            >
              <el-tooltip
                placement="left-start"
                v-if="param.label.length>=4"
                :content="param.label"
              >
                <span
                  style="width:4em;line-height: 1.4;"
                  class="ellipsis"
                >{{param.label}}</span>
              </el-tooltip>
              <span
                style="wdith:4em;display:inline-block;"
                v-else
              >{{param.label}}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="flex-center">
      <el-button @click="handleCancelClick('/edit-risk-tip')">取消</el-button>
      <yh-button
        type="primary"
        @click="handleSaveClick(API.updateRiskTip, '/edit-risk-tip')"
      >保存</yh-button>
    </div>
  </div>
</template>
<script>
import mixin from './mixin';

export default {
  name: 'EditRiskTip',
  mixins: [mixin],

  data() {
    const rules = {
      riskTipName: [{ required: true, message: this.$MSG.M0140, trigger: 'blur' }, {
        trigger: 'blur',
        validator: (rule, value, cb) => {
          if (value.length > 50) {
            cb(this.$MSG.M0114);
          } else {
            cb();
          }
        },
      }],
      riskTipDescribe: [{ required: true, message: this.$MSG.M0140, trigger: 'blur' }, {
        trigger: 'blur',
        validator: (rule, value, cb) => {
          if (value.length > 200) {
            cb(this.$MSG.M0115);
          } else {
            cb();
          }
        },
      }],
      riskTipDetails: [{ required: true, message: this.$MSG.M0140 }, {
        validator: (rule, value, cb) => {
          if (value.length > 500) {
            cb(this.$MSG.M0116);
          } else {
            cb();
          }
        },
      }],
      status: [{ required: true, message: this.$MSG.M0140 }],
    };
    return {
      rules,
      addData: {
        status: '',
        riskTipName: '',
        riskTipDescribe: '',
        riskTipDetails: '',
      },
      riskTipStatusList: [{
        label: '启用',
        value: '1',
      }, {
        label: '禁用',
        value: '0',
      }],
      paramList: [],
    };
  },
  activated() {
    const { id } = this.$route.query;
    if (!id) {
      return;
    }
    this.getRiskTip(id);
  },
  methods: {
    getRiskTip(id) {
      this.$_post(this.$API.getRiskTip, {
        data: {
          id,
        },
      }).then((res) => {
        this.addData = res.data.info;
        this.editContent.innerHTML = res.data.info.riskTipDetails.replace(/\n/g, '<br>');
        this.addData.riskTipDetails = this.parseHTML(this.editContent.childNodes);
      });
    },
  },
};
</script>
